<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Attendance CRON Management">
      <a @click="$router.back()">
        <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
          <v-icon left>mdi-arrow-left</v-icon>back
        </v-btn>
        <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10"
          style="opacity:.6;">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </a>
      <v-card-component>
        <v-row>
          <v-col cols="12" md="3">
            <v-autocomplete class="mt-3" label="Year *" v-model="year" :items="years">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete class="mt-3" label="Month *" v-model="month" :items="months">
            </v-autocomplete>
          </v-col>
        </v-row>

        <v-col>
          <div class="text-right">
            <a @click="$router.back()">
              <v-btn class="px-2 ml-1 ma-1" min-width="0">
                Cancel
              </v-btn>
            </a>
            <v-btn color="success" @click="startCRON()" class="px-2 ml-1 ma-1" min-width="0">
              <span class="ml-1">START cron</span>
            </v-btn>
          </div>
        </v-col>
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script>
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
// import _ from 'lodash'

export default {
  name: 'attendanceCRON',
  components: { VCardComponent, MaterialCard },
  async created () {
    this.yearOptionsHandler()
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function (val) {
      console.log(val.id)
    },
    academicYear: async function (val) {
      console.log(val.id)
    }
  },
  data () {
    return {
      years: [],
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      year: '',
      month: ''
    }
  },
  methods: {
    async startCRON () {
      try {
        if (this.year !== '' && this.month !== '') {
          const response = await http.get(`${constants.API_URL}/api/attendanceModule/attendancecron?month=${this.months.indexOf(this.month) + 1}&year=${this.year}`)
          this.year = ''
          this.month = ''
          this.okMsg(response.data)
        } else {
          this.errMsg('Please fill both year and month.')
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    yearOptionsHandler () {
      let max = new Date().getFullYear()
      let min = max - 10

      for (var i = min; i <= max; i++) {
        this.years.push(i)
      }
      this.years = this.years.reverse()
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>

<style scoped>
#status {
  text-align: right;
}
.homework-description {
  border: solid rgb(223 179 196) 1px;
}
.left-auto {
  margin-left: 50%;
}
.relative {
  position: relative;
}
.close-icon {
  position: absolute;
  right: 0;
  top: 0;
}
.upload-title {
  font-weight: 600;
}
</style>
